import { createPropsFinder, createPropsSelector } from './utils';

export const selectDayKindCalendar = (state) => state.bo.dayKindCalendar.dayKindCalendar;

export const selectDayKindCalendarByProps = createPropsSelector(selectDayKindCalendar);
export const findDayKindCalendarByProps = createPropsFinder(selectDayKindCalendar);
